/* ============================================================================
   DAILE custom — атрибуция заказов (TASK81, ТЗ «Захват UTM в заказ»).
   ----------------------------------------------------------------------------
   Зачем: комиссия агентства считается по меткам В ЗАКАЗЕ (order attributes,
   видны в админке и в CSV-экспорте), а не по кукам аналитики.

   Как работает:
   1) На каждой загрузке страницы читаем utm_* / gclid / fbclid из URL.
   2) localStorage: `daile_attr_first` — пишется ОДИН раз (первое касание,
      никогда не перезаписывается); `daile_attr_last` — при каждом визите
      С МЕТКАМИ (прямой заход историю НЕ стирает). Приватный режим без
      localStorage → молчаливый fallback на переменную в памяти.
   3) Любой успешный POST /cart/add (все пути: PDP-форма, апсейлы дровера,
      кастомайзер) ловится обёрткой fetch → следом POST /cart/update.js
      с cart attributes (БЕЗ префикса «_» — видны в Additional details заказа).

   Не трогает _line_id/_parent_line (это line-item properties, другой механизм).
   Ничего не шлёт наружу — только Shopify Cart API. ES5, деградирует молча.
   ============================================================================ */
(function () {
  'use strict';
  if (window.__daileAttrLoaded) return;
  window.__daileAttrLoaded = true;

  var KEY_FIRST = 'daile_attr_first';
  var KEY_LAST = 'daile_attr_last';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- хранилище: localStorage → fallback в память ---------- */
  var mem = {};
  var storage = (function () {
    try {
      var t = '__daile_attr_test__';
      window.localStorage.setItem(t, '1');
      window.localStorage.removeItem(t);
      return {
        get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return mem[k] || null; } },
        set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) { mem[k] = v; } }
      };
    } catch (e) {
      return {
        get: function (k) { return mem[k] || null; },
        set: function (k, v) { mem[k] = v; }
      };
    }
  })();

  function readJSON(key) {
    try { return JSON.parse(storage.get(key) || 'null'); } catch (e) { return null; }
  }

  /* ---------- захват меток из URL ---------- */
  function captureFromUrl() {
    var q;
    try { q = new URLSearchParams(window.location.search); } catch (e) { return; }
    var payload = {
      source: q.get('utm_source') || '',
      medium: q.get('utm_medium') || '',
      campaign: q.get('utm_campaign') || '',
      content: q.get('utm_content') || '',
      term: q.get('utm_term') || '',
      gclid: q.get('gclid') || '',
      fbclid: q.get('fbclid') || ''
    };
    var hasAny = payload.source || payload.medium || payload.campaign ||
      payload.content || payload.term || payload.gclid || payload.fbclid;
    if (!hasAny) return; // прямой заход — историю не трогаем

    payload.ts = new Date().toISOString();
    var json = JSON.stringify(payload);
    if (!readJSON(KEY_FIRST)) storage.set(KEY_FIRST, json); // first-touch: только один раз
    storage.set(KEY_LAST, json);                            // last-touch: всегда
  }

  /* ---------- cart attributes (формат из ТЗ; пустые поля не шлём) ---------- */
  function buildCartAttributes() {
    var first = readJSON(KEY_FIRST);
    var last = readJSON(KEY_LAST);
    if (!first && !last) return null;
    var attrs = {};
    if (first) {
      if (first.source) attrs.attr_first_source = first.source;
      if (first.ts) attrs.attr_first_ts = first.ts;
    }
    if (last) {
      if (last.source) attrs.attr_last_source = last.source;
      if (last.medium) attrs.attr_last_medium = last.medium;
      if (last.campaign) attrs.attr_last_campaign = last.campaign;
      if (last.content) attrs.attr_last_content = last.content;
      if (last.ts) attrs.attr_last_ts = last.ts;
    }
    var any = false;
    for (var k in attrs) { if (attrs.hasOwnProperty(k)) { any = true; break; } }
    return any ? attrs : null;
  }

  /* ---------- запись в корзину (fire-and-forget, с анти-спамом) ---------- */
  var syncInFlight = false;
  var lastSyncTs = 0;
  function syncToCart() {
    try {
      var attrs = buildCartAttributes();
      if (!attrs) return;
      var now = Date.now();
      if (syncInFlight || (now - lastSyncTs) < 4000) return; // перезапись безопасна, но не спамим
      syncInFlight = true;
      window.fetch(ROOT + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).then(function () {
        syncInFlight = false;
        lastSyncTs = Date.now();
      }).catch(function () { syncInFlight = false; });
    } catch (e) { syncInFlight = false; /* молча — атрибуция не должна ломать корзину */ }
  }

  /* ---------- перехват добавлений в корзину ----------
     Одна точка вместо правки трёх файлов (PDP-форма/дровер/кастомайзер —
     все идут через fetch /cart/add). Только наблюдение: исходный запрос
     не меняется, следом отдельный update с атрибутами. */
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = '';
      try { url = (typeof input === 'string') ? input : (input && input.url) || ''; } catch (e) { /* no-op */ }
      var p = origFetch.apply(this, arguments);
      if (url && url.indexOf('/cart/add') !== -1) {
        p.then(function (res) {
          if (res && res.ok) window.setTimeout(syncToCart, 60);
        }).catch(function () { /* no-op */ });
      }
      return p;
    };
  }

  captureFromUrl();

  /* публичный API — на случай явного вызова из другого кода/консоли */
  window.DaileAttribution = {
    getFirst: function () { return readJSON(KEY_FIRST); },
    getLast: function () { return readJSON(KEY_LAST); },
    buildCartAttributes: buildCartAttributes,
    syncToCart: syncToCart
  };
})();
